var m={S:{min:0,max:576},M:{min:577,max:980},L:{min:981,max:1280},XL:{min:1281,max:1440}};export{m as default};
